import selectEntityItem from "./entityItem"

export default function selectCreatedId(state, model, id) {
  const entity = selectEntityItem(state, model, id)

  return entity && entity.createdId
}
